import { useState } from "react";
import OtpInput from './totpInput';
import { toast } from "react-toastify";
import { AxiosError } from "axios";
import { useNavigate } from "react-router-dom";

// Components
import { verifyRegisterApi , } from "../services/auth";
import { registerApi } from "../services/user";

//Get value as Props
export type Props = {
  onToggle: (b: boolean) => void;
  username: string;
  password: string;
  givenName: string;
  lastName: string;
  email: string; 
  phoneNumber: string;
};


//Pass value from register in here as prop
const RegisterOTP = (props:Props) => {
    //Get user input and set it to state
    const [otp, setOtp] = useState('');
    const onChange = (value: string) => setOtp(value);

    let navigate = useNavigate();

    //Function to handle otp verification
    const handleSubmit = async () => {
      if(otp.length < 6) {
        toast.error("Please fill in all fields")
      }
      else {
        try {
          const response = await verifyRegisterApi(props.phoneNumber,otp);
            if(response.status === 200) {
                try {
                  const formData = new FormData();
                  formData.append("username", props.username);
                  formData.append("password", props.password);
                  formData.append("givenName", props.givenName);
                  formData.append("lastName", props.lastName);
                  formData.append("email", props.email);
                  formData.append("phone_number",props.phoneNumber);
                  const response = await registerApi(formData);
                  if (response.message === "Success") {
                    toast.success("You have successfully registered an account!")
                    props.onToggle(false); 
                    navigate("/login");
                  } else if (response === "Email Registered") {
                    toast.error("Email is already registered")
                  }
                } catch (e) {
                  if (e instanceof AxiosError && e.response && e.response.data.message === "Email Registered") {
                    toast.error("Email is already registered")
                  }
                }
            }
        } catch (e) {
          if (e instanceof AxiosError && e.response && e.response.status === 403) {
            toast.error("Invalid OTP");
          }
        }
      }
    };

    return (
        <>
          {props.onToggle ? (
            <>
              <div
                className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none"
              >
                <div className="relative w-auto my-6 mx-auto max-w-3xl">
                  {/*content*/}
                  <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                    {/*header*/}
                    <button type="button" className="absolute top-3 right-2.5 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-gray-800 dark:hover:text-white"  onClick={() => props.onToggle(false)}>
                          <svg aria-hidden="true" className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd"></path></svg>
                          <span className="sr-only">Close modal</span>
                    </button>
                    <div className="flex items-start justify-between p-5 border-b border-solid border-slate-200 rounded-t my-8">
                      <h3 className="text-3xl font-semibold">Please Enter the OTP to Verify Your New Account</h3>
                    </div>
                    {/*body*/}
                        <div className="container mx-auto">
                            <div className="max-w-sm mx-auto md:max-w-lg">
                                <div className="w-full">
                                    <div className="bg-white h-64 py-3 rounded text-center">
                                        <div className="flex flex-col mt-4">
                                            <span>A OTP(one time Password) has been send to your phone number</span>
                                        </div>
                                        <OtpInput value={otp} valueLength={6} onChange={onChange} />
                                        {/* <div className="flex justify-center text-center mt-5">
                                            <a className="flex items-center text-blue-700 hover:text-blue-900">FYI: Your OTP will expire in 60 seconds.</a>
                                        </div> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    {/*footer*/}
                    <div className="flex items-center justify-end p-6 border-t border-solid border-slate-200 rounded-b">
                      <button
                        className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500"
                        type="button"
                        onClick={() => handleSubmit()}>
                        Verify Account
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
            </>
          ) : null}
        </>
    );
}

export default RegisterOTP